var i=function(r){return r.VIDEO="video",r.IMAGE="image",r}({});export{i as MediaContentType};